/** Cookie name for JWT / auth token from second API login. */
export const AUTH_TOKEN_COOKIE_NAME = "nomio_auth_token";

const MAX_AGE_SEC = 60 * 60 * 24 * 7; // 7 days

/**
 * In-memory cache of the token. We use this in the SecondApi request
 * interceptor to avoid any race or encoding issue when reading the cookie
 * immediately after writing it (e.g. right after login → next request).
 *
 * The cookie is still the source of truth for persistence across reloads.
 */
let tokenCache = null;

export function setAuthTokenCookie(token) {
  if (!token || typeof token !== "string") return;
  tokenCache = token;
  const encoded = encodeURIComponent(token);
  let cookie = `${AUTH_TOKEN_COOKIE_NAME}=${encoded}; path=/; max-age=${MAX_AGE_SEC}; SameSite=Lax`;
  if (typeof window !== "undefined" && window.location?.protocol === "https:") {
    cookie += "; Secure";
  }
  document.cookie = cookie;
}

function readTokenFromCookie() {
  if (typeof document === "undefined") return null;
  const prefix = `${AUTH_TOKEN_COOKIE_NAME}=`;
  const parts = document.cookie.split("; ");
  for (const part of parts) {
    if (part.startsWith(prefix)) {
      const raw = part.slice(prefix.length);
      try {
        return decodeURIComponent(raw);
      } catch (e) {
        // If decoding fails (corrupt cookie), return raw value as fallback.
        return raw;
      }
    }
  }
  return null;
}

export function getAuthTokenCookie() {
  if (tokenCache) return tokenCache;
  const fromCookie = readTokenFromCookie();
  if (fromCookie) tokenCache = fromCookie;
  return fromCookie;
}

export function clearAuthTokenCookie() {
  tokenCache = null;
  if (typeof document === "undefined") return;
  document.cookie = `${AUTH_TOKEN_COOKIE_NAME}=; path=/; max-age=0; SameSite=Lax`;
}
